import { render, staticRenderFns } from "./EstablishmentRoleAdd.vue?vue&type=template&id=37b09f28&scoped=true&"
import script from "./EstablishmentRoleAdd.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b09f28",
  null
  
)

export default component.exports